import React from 'react';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import routes from 'app/routes';
import List from './Pages/List/Index';
import NewResource from './Pages/New/Index';
import EditResource from './Pages/Edit/Index';

export default function Index() {
  const router = createBrowserRouter([
    {
      path: routes.admin.resources.index,
      element: <List />,
      children: [
        {
          path: routes.admin.resources.new,
          element: <NewResource />,
        },
        {
          path: routes.admin.resources.edit(),
          element: <EditResource />,
        },
      ],
    },

  ]);

  return (
    <RouterProvider router={router} />
  );
}
